/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { AcceptAodRunRunActionsMutationRequest, AcceptAodRunRunActionsMutationResponse, AcceptAodRunRunActionsPathParams, AcceptAodRunRunActions400, AcceptAodRunRunActions404 } from "../models/AcceptAodRunRunActions";

export function getAcceptAodRunRunActionsUrl(id: AcceptAodRunRunActionsPathParams["id"]) {
  const res = { method: 'PUT', url: `/aod-runs/${id}/accept` as const }
  return res
}

/**
 * @description Re-executes the AOD run job with minimum efficiency requirement removed for runs with COMPLETED_WITHOUT_EXPORT status
 * @summary Accept a run
 * {@link /aod-runs/:id/accept}
 */
export async function acceptAodRunRunActions(id: AcceptAodRunRunActionsPathParams["id"], data: AcceptAodRunRunActionsMutationRequest, config: Partial<RequestConfig<AcceptAodRunRunActionsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AcceptAodRunRunActionsMutationResponse, ResponseErrorConfig<AcceptAodRunRunActions400 | AcceptAodRunRunActions404>, AcceptAodRunRunActionsMutationRequest>({ method : "PUT", url : getAcceptAodRunRunActionsUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}